module.exports = __webpack_public_path__ + "img/生物制药_03.c855b0fd.png";